import type { ReactNode } from "react";
import { cx } from "./cx";
import { IconButton } from "./button";
import { Icon, X } from "./icon";

export interface DrawerProps {
  open: boolean;
  onClose?: () => void;
  side?: "left" | "right";
  title: ReactNode;
  children: ReactNode;
  /** "inline" contains the panel inside a `.pz-well` ancestor (see Modal). */
  layout?: "viewport" | "inline";
  /** Render a scrim behind the panel (persistent editor panels omit it). */
  scrim?: boolean;
  className?: string;
}

/** Side panel — editor and filter panels (M3/M4) compose from this. */
export function Drawer({
  open,
  onClose,
  side = "right",
  title,
  children,
  layout = "viewport",
  scrim = false,
  className,
}: DrawerProps) {
  if (!open) return null;
  const inline = layout === "inline";
  return (
    <>
      {scrim && <div className={cx("pz-scrim", inline && "pz-scrim--inline")} onClick={onClose} aria-hidden />}
      <aside
        className={cx("pz-drawer", `pz-drawer--${side}`, inline && "pz-drawer--inline", className)}
        aria-label={typeof title === "string" ? title : undefined}
      >
        <div className="pz-drawer__header">
          <h2 className="pz-drawer__title">{title}</h2>
          {onClose && (
            <IconButton label="Close panel" variant="ghost" size="sm" onClick={onClose}>
              <Icon icon={X} size="md" />
            </IconButton>
          )}
        </div>
        <div className="pz-drawer__body">{children}</div>
      </aside>
    </>
  );
}
